import { apiRequest } from './core/client';

export interface TrainingRecord {
  messageId: string;
  accountId: string;
  label: 'spam' | 'ham';
  status: 'trained' | 'skipped' | 'failed';
  alreadyTrained?: boolean;
  trainedAt?: string | null;
  source?: string | null;
  timestamp?: string | null;
}

interface TrainMessageResponse {
  success: boolean;
  training: TrainingRecord;
}

interface TrainMessageParams {
  accountId: string;
  messageId: string;
  source?: string;
}

async function trainMessage(params: TrainMessageParams, label: 'spam' | 'ham'): Promise<TrainingRecord> {
  const { accountId, messageId, source } = params;
  if (!accountId || !messageId) {
    throw new Error('Missing training identifiers');
  }

  const pathSegment = label === 'ham' ? 'train-good' : 'train-spam';
  const payload = source ? { source } : undefined;

  const response = await apiRequest<TrainMessageResponse>({
    path: `/messages/${encodeURIComponent(messageId)}/${pathSegment}`,
    method: 'POST',
    accountId,
    body: payload,
  });

  return response.training;
}

export function trainMessageAsSpam(params: TrainMessageParams): Promise<TrainingRecord> {
  return trainMessage(params, 'spam');
}

export function trainMessageAsGood(params: TrainMessageParams): Promise<TrainingRecord> {
  return trainMessage(params, 'ham');
}
